export default {
  window: {
    width: 0,
    height: 0,
  },
}
